export default __webpack_public_path__ + "static/media/ftv.aea304da.png";